import request from '../../lib/helpers/requestApi';
import { NotificationMessages } from './types';

/** Метод получения списка всех непрочитанных сообщений пользователя */
export const getAllNotificationForPeriodAPI = request<NotificationMessages, { date?: string }>({
  method: 'notification.getAllNotificationForPeriod',
});

/** Делает сообщение прочитанным */
export const setNotificationIsReadAPI = request<boolean, { notification_id: number }>({
  method: 'notification.setNotificationIsRead',
});

/** Метод получения списка всех непрочитанных сообщений пользователя */
export const setAllNotificationIsReadAPI = request<boolean>({
  method: 'notification.setAllNotificationIsRead',
});
